import React from 'react'
import Hero from './components/mission-shakti/Hero'
import Main from './components/mission-shakti/Main'

const MissionShakti = () => {
  return (
    <>
        <div>
          <Hero/>
          <Main/>
        </div>
    </>
  )
}

export default MissionShakti